/* WhatsApp button click tracking — pushes dataLayer event for GA4/GTM */
(function () {
  function track(btn) {
    var payload = {
      event: 'whatsapp_click',
      wa_location: btn.getAttribute('data-wa-location') || 'unknown',
      wa_product: btn.getAttribute('data-wa-product') || ''
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
  function bind(scope) {
    (scope || document).querySelectorAll('[data-wa-chat]:not([data-wa-bound])').forEach(function (btn) {
      btn.setAttribute('data-wa-bound', '1');
      btn.addEventListener('click', function () { track(btn); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  // Re-bind for dynamically injected content
  if (window.MutationObserver) {
    new MutationObserver(function () { bind(document); }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Product page: place WhatsApp below wholesale price button */
(function () {
  function placeProductButton() {
    var slot = document.getElementById('wa-product-slot');
    var target = document.querySelector('#MainContent .wholesale-link');

    if (!slot || !target) return;

    var btnWrap = slot.querySelector('.wa-chat-wrap');
    if (!btnWrap) return;

    target.insertAdjacentElement('afterend', btnWrap);

    btnWrap.style.width = '100%';
    btnWrap.style.marginTop = '14px';
    btnWrap.setAttribute('data-wa-placed', '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeProductButton);
  } else {
    placeProductButton();
  }
})();